export default "__VITE_ASSET__039edfba__"